import { Trans } from "react-i18next";

import type { NotificationContextOf } from "../types";

export default function PollClosed({
  context,
}: {
  context?: NotificationContextOf<"pollClosed">;
}) {
  return (
    <Trans
      i18nKey="notifications.pollClosed"
      values={{ poll: context?.pollName || "Deleted" }}
    />
  );
}
